import LunrSearch from './src/lunr'

export default LunrSearch



// WEBPACK FOOTER //
// ./index.js